module.exports = __webpack_public_path__ + "image-83cf1da19a2d.png";